import { DEFAULT_LANGUAGE } from 'components/Wizards/Wizard/Form/LanguageInputField/defaultContentLanguage'

/**
 * Fieldset completion requests need an explicit `language` for correct output; Formik often
 * omits `language` while it is still "" before defaults apply, which made autofill default to English.
 */
export function completedFieldsWithResolvedLanguage(
  completedFields: Record<string, unknown>,
  formLanguage: unknown,
  defaultContentLanguage: string | undefined,
): Record<string, unknown> {
  const hasFormLang = typeof formLanguage === 'string' && formLanguage.length > 0
  const language = hasFormLang ? formLanguage : (defaultContentLanguage ?? DEFAULT_LANGUAGE)
  return { ...completedFields, language }
}
